import React from 'react'

export const SuspensePage = ({Component,...props}) => <React.Suspense fallback={null}><Component {...props}/></React.Suspense>